import PropTypes from "prop-types";
import React from "react";

import { Button } from "@material-ui/core";
import { Card, EmptyState } from "@shopify/polaris";
import { useAdmin } from "context/admin";
import { useHistory } from "react-router-dom";
import LoadingPage from "shared/LoadingPage";

export default function ShopList({ loading, shops }) {
  const history = useHistory();
  const admin = useAdmin();

  // Show loading state
  if (loading) {
    return <LoadingPage />;
  }

  // Handle error state when shops is null/undefined or empty array due to API failure
  if (!shops || (Array.isArray(shops) && shops.length === 0)) {
    return (
      <Card sectioned>
        <EmptyState
          heading="Unable to load shops"
          action={{
            content: "Retry",
            onAction: () => {
              console.log("Retrying fetchShops...");
              admin.fetchShops();
            },
          }}
          secondaryAction={{
            content: "Refresh Page",
            onAction: () => window.location.reload(),
          }}
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
        >
          <p>
            There was an issue connecting to the server. This could be due to:
          </p>
          <ul style={{ textAlign: "left", marginTop: "10px" }}>
            <li>Server maintenance or temporary issues</li>
            <li>Network connectivity problems</li>
            <li>Authentication session expired</li>
          </ul>
          <p style={{ marginTop: "15px" }}>
            Please try again, or refresh the page if the problem persists.
          </p>
        </EmptyState>
      </Card>
    );
  }

  // Normal state - display shops
  return shops.map((shop) => (
    <Card sectioned data-cy="StoreCard" key={shop.id} title={shop.current.name}>
      <p>Customize Shop Settings, view orders and deliveries</p>
      <Button
        data-cy="goToStoreBtn"
        onClick={() => history.push(`/shops/${shop.id}`)}
      >
        Go To Store
      </Button>
    </Card>
  ));
}

ShopList.propTypes = {
  shops: PropTypes.array,
  loading: PropTypes.bool,
};
